import { Button, FormControlLabel, Switch } from '@mui/material'
import { useUpdateAccount } from 'queries/accounts';
import React, { useState, useEffect } from 'react'

const AccountPlan = ({ formData, handleRefresh }) => {
    const [formState, setFormState] = useState({
        number_of_team_member: 0,
        number_of_additional_accounts: 0,
        number_of_ai_agents: 0,
        unlimited_ai_agents: false,
        number_of_tokens: 0
    });
    const [hasChanges, setHasChanges] = useState(false);

    // Initialize form state when formData changes
    useEffect(() => {
        if (formData) {
            setFormState({
                number_of_team_member: formData?.number_of_team_member || 0,
                number_of_additional_accounts: formData?.number_of_additional_accounts || 0,
                number_of_ai_agents: formData?.number_of_ai_agents || 0,
                unlimited_ai_agents: formData?.unlimited_ai_agents || false,
                number_of_tokens: formData?.number_of_tokens || 0
            });
        }
    }, [formData]);

    // Check for changes
    useEffect(() => {
        if (formData) {
            const hasChanged =
                formState.number_of_team_member !== (formData?.number_of_team_member || 0) ||
                formState.number_of_additional_accounts !== (formData?.number_of_additional_accounts || 0) ||
                formState.number_of_ai_agents !== (formData?.number_of_ai_agents || 0) ||
                formState.unlimited_ai_agents !== (formData?.unlimited_ai_agents || false) ||
                formState.number_of_tokens !== (formData?.number_of_tokens || 0);

            setHasChanges(hasChanged);
        }
    }, [formState, formData]);

    const handleInputChange = (field, value) => {
        setFormState(prev => ({
            ...prev,
            [field]: parseInt(value) || 0
        }));
    };

    const handleToggleChange = (field, value) => {
        setFormState(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const { mutateAsync: updateAccountPlan, isPending: loading } = useUpdateAccount(true);

    const AccountUpdate = async () => {
        if (!hasChanges) return;

        const payload = {
            ...formState,
            _id: formData.id,
        };

        try {
            const { response } = await updateAccountPlan(payload);
            if (response) {
                console.log('Account updated successfully');
                setHasChanges(false);
            }
        } catch (error) {
            console.error('Error updating account:', error);
        }
    };

    return (
        <div>
            <p style={{ color: "gray", fontSize: "14px" }}>
                This is the plan allowance for this account you can edit its allowance here.
            </p>

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <label>Add team members</label>
                <input
                    value={formState.number_of_team_member}
                    onChange={(e) => handleInputChange('number_of_team_member', e.target.value)}
                    type="number"
                    placeholder=''
                    style={{ width: "150px", padding: "10px", borderRadius: "5px", border: "1px solid gray", marginTop: "10px" }}
                    disabled={loading}
                />
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <label>Create Additional Accounts</label>
                <input
                    value={formState.number_of_additional_accounts}
                    onChange={(e) => handleInputChange('number_of_additional_accounts', e.target.value)}
                    type="number"
                    placeholder=''
                    style={{ width: "150px", padding: "10px", borderRadius: "5px", border: "1px solid gray", marginTop: "10px" }}
                    disabled={loading}
                />
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <label>Build Custom AI Agents</label>
                <input
                    value={formState.number_of_ai_agents}
                    onChange={(e) => handleInputChange('number_of_ai_agents', e.target.value)}
                    type="number"
                    placeholder=''
                    style={{ width: "150px", padding: "10px", borderRadius: "5px", border: "1px solid gray", marginTop: "10px" }}
                    disabled={loading || formState.unlimited_ai_agents}
                />
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px" }}>
                <label></label>
                <FormControlLabel
                    control={
                        <Switch
                            checked={formState.unlimited_ai_agents}
                            onChange={(e) => handleToggleChange('unlimited_ai_agents', e.target.checked)}
                            disabled={loading}
                        />
                    }
                    label="Unlimited"
                />
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <label>AI Token usage</label>
                <input
                    value={formState.number_of_tokens}
                    onChange={(e) => handleInputChange('number_of_tokens', e.target.value)}
                    type="number"
                    placeholder=''
                    style={{ width: "150px", padding: "10px", borderRadius: "5px", border: "1px solid gray", marginTop: "10px" }}
                    disabled={loading}
                />
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div></div>
                <Button
                    onClick={AccountUpdate}
                    variant="contained"
                    style={{
                        marginTop: "20px",
                        marginLeft: "auto",
                        width: 'fit-content',
                        opacity: hasChanges ? 1 : 0.6
                    }}
                    disabled={loading || !hasChanges}
                >
                    {loading ? 'Updating...' : 'Update'}
                </Button>
            </div>
        </div>
    )
}

export default AccountPlan
